import { render, staticRenderFns } from "./idp-return.vue?vue&type=template&id=2cecab36&"
import script from "./idp-return.ts?vue&type=script&lang=ts&"
export * from "./idp-return.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports